import { FC } from "react";
import { useTranslation } from "react-i18next";

import { InfoCircle } from "@/assets/icons/ds";

/**
 * Persistent agent-session indicator rendered in the PortalPageLayout `banners`
 * slot. Stays in document flow (not fixed) so it does not fight the shell
 * header or content padding.
 */
export const AgentLoginBanner: FC = () => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="agent-login-banner"
      className="sticky top-14 z-10 flex w-full items-center justify-center gap-2 bg-surface-info-inverse px-4 py-2 desktop:top-0"
      role="status"
    >
      <InfoCircle
        className="size-5 shrink-0 text-foreground-primary-inverse"
        aria-hidden="true"
      />
      <p className="text-body-sm font-semibold leading-none text-foreground-primary-inverse">
        {t("portal:common.alerts.agentLogin")}
      </p>
    </div>
  );
};
